import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { TitleService } from 'wflow-cdk';
import { SkeletonComponent } from 'wflow-ui';

@Component({
  selector: 'wf-page-title',
  template: `
    @if (title(); as title) {
      {{ title }}
    } @else {
      <wui-text-skeleton width="120" height="40" />
    }
  `,
  styles: [
    `
      .wf-page-title {
        display: block;
        max-width: 300px;

        font-size: var(--wf-xl-font-size);
        line-height: var(--wf-xl-line-height);
        letter-spacing: var(--wf-xl-letter-spacing);
        font-weight: var(--wf-font-weight-demibold);

        &--sm {
          font-size: var(--wf-base-font-size);
          line-height: var(--wf-sm-line-height);
          letter-spacing: normal;
          font-weight: var(--wf-font-weight-demibold);
        }

        @media (min-width: 1200px) {
          max-width: 500px;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SkeletonComponent],
  host: {
    class: 'wf-page-title ellipsis',
    '[class.wf-page-title--sm]': 'isMobile()',
  },
})
export class PageTitleComponent {
  readonly title = inject(TitleService).title;
  readonly isMobile = input(false);
}
